import {
  flightPlanFillLayerByStatus,
  flightPlanOutlineLayerByStatus,
} from '@components/map/layers/flightPlans/operational/flightPlan.layer';
import { useSelectorWithReplayMode } from '@hooks/useSelectorWithReplayMode';
import { selectFilteredFlightPlanFeatures } from '@redux/situation/situation.selectors';
import { isFeatureCollection } from '@utils/map/map.utils';
import { Layer, Source } from 'react-map-gl/mapbox';

import { SourceNameEnum } from '@/types/map.types';

function FlightPlanLayer() {
  const flightPlanFeatures = useSelectorWithReplayMode(selectFilteredFlightPlanFeatures);

  if (!isFeatureCollection(flightPlanFeatures)) {
    return null;
  }

  return (
    <Source id={SourceNameEnum.FLIGHT_PLANS} type="geojson" data={flightPlanFeatures}>
      <Layer {...flightPlanFillLayerByStatus} />
      <Layer {...flightPlanOutlineLayerByStatus} />
    </Source>
  );
}

export default FlightPlanLayer;
